import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiButtonOverrides = {
  defaultProps?: ComponentsProps['MuiButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiButton'];
  variants?: ComponentsVariants['MuiButton'];
}

function getMuiButtonOverride(): MuiButtonOverrides {
  return {
    styleOverrides: {
      root: {
        fontSize: "1.2rem",
        lineHeight: "1.6rem",
        textTransform: "unset",
        paddingBlock: "var(--cta-padding-block)",
        paddingInline: "var(--cta-padding-inline)",
        borderRadius: "var(--cta-rounded)",
        border: "var(--cta-bdr-width) solid"
      },
      containedPrimary: {
        color: "var(--cta-clr-primary)",
        borderColor: "var(--cta-bdr-primary)",
        backgroundColor: "var(--cta-bg-primary)",
        ":hover": {
          backgroundColor: "var(--cta-bg-primary-hover)",
        }
      },
      outlinedPrimary: {
        color: "var(--cta-clr-primary-outlined)",
        borderColor: "var(--cta-bdr-primary-outlined)",
        backgroundColor: "var(--cta-bg-primary-outlined)",
        ":hover": {
          color: "var(--cta-clr-primary-outlined-hover)",
          backgroundColor: "var(--cta-bg-primary-outlined-hover)",
          borderColor: "var(--cta-bdr-primary-outlined-hover)",
        }
      },
      text: {
        border: "var(--cta-bdr-width) solid"
      },
      textPrimary: {
        color: "var(--cta-clr-text)",
        borderColor: "var(--cta-bdr-text)",
        backgroundColor: "var(--cta-bg-text)",
        ":hover": {
          borderColor: "var(--cta-bdr-text-hover)",
          backgroundColor: "var(--cta-bg-text-hover)",
        }
      },
    }
  }
}

export default getMuiButtonOverride;